"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Button = _interopRequireDefault(require("../../Button"));
var _OnClickOutside = _interopRequireDefault(require("../../OnClickOutside"));
var CustomList = function CustomList(props) {
  var className = props.className,
    isOverflown = props.isOverflown,
    options = props.options,
    onChoose = props.onChoose,
    handleClose = props.handleClose;
  var handleClick = function handleClick(e) {
    onChoose(e);
    handleClose();
  };
  var handleKeyPress = function handleKeyPress(e) {
    return onChoose(e);
  };
  return /*#__PURE__*/_react["default"].createElement(_OnClickOutside["default"], {
    onClickOutside: handleClose
  }, /*#__PURE__*/_react["default"].createElement(StyledOptions, {
    className: className,
    isOverflown: isOverflown
  }, options.map(function (option) {
    return (
      // @ts-ignore
      option.value > -1 ? /*#__PURE__*/_react["default"].createElement(StyledOption, {
        key: option.value
      }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        functional: true,
        onClick: handleClick,
        onKeyDown: handleKeyPress,
        value: option.value
      }, option.value === 0 ? option.title : "".concat(option.value, " ").concat(option.title))) : /*#__PURE__*/_react["default"].createElement(StyledHead, null, option.title)
    );
  })));
};
var StyledHead = _styledComponents["default"].li.withConfig({
  displayName: "CustomList__StyledHead",
  componentId: "sc-hcxsqa-0"
})(["width:100%;min-height:46px;font-size:12px;line-height:16px;color:#17181a;background:#fffbe5;border:4px solid #fff;display:flex;align-items:center;text-align:center;box-sizing:border-box;"]);
var StyledOptions = _styledComponents["default"].ul.withConfig({
  displayName: "CustomList__StyledOptions",
  componentId: "sc-hcxsqa-1"
})(["background-color:#fff;border-radius:4px;box-shadow:0 2px 10px 0 rgba(0,0,0,0.1);position:absolute;z-index:2;width:140px;top:0;font-size:14px;", ""], function (_ref) {
  var isOverflown = _ref.isOverflown;
  return isOverflown ? 'right: 105%' : 'left: 105%;';
});
var StyledOption = _styledComponents["default"].li.withConfig({
  displayName: "CustomList__StyledOption",
  componentId: "sc-hcxsqa-2"
})(["padding:0 3px;min-height:24px;line-height:24px;border-top:1px solid transparent;> button{text-align:center;height:100%;margin:2px 0;padding:0 8px;width:100%;}& + &{border-top:1px solid rgba(194,197,204,0.2);}&:first-child{border-radius:4px 4px 0 0;}&:last-child{border-radius:0 0 4px 4px;}&:hover{background-color:#e6f2ff;}", ""], function (_ref2) {
  var selected = _ref2.selected;
  return selected && "\n    color: #fff;\n    background-color: #007aff;\n  ";
});
var _default = exports["default"] = CustomList;